/**
 * @summary
 * <blockquote>Auto-generated static resources const for RBAC system</blockquote>
 * 
 * @remarks
 * This file is auto-generated by @tools/generate-resource-types
 * Do not edit manually - changes will be overwritten.
 */

import { MODULE_RESOURCES } from './MODULE_RESOURCES';
import { PAGE_RESOURCES } from './PAGE_RESOURCES';
import { ROUTE_RESOURCES } from './ROUTE_RESOURCES';
import { DATABASE_RESOURCES } from './DATABASE_RESOURCES';
import { UI_RESOURCES } from './UI_RESOURCES';
import { VIEW_RESOURCES } from './VIEW_RESOURCES';

/**
 * @group Constants
 * @summary
 * <blockquote>All static resources combined</blockquote>
 * 
 * @example
 * ```typescript
 * import { STATIC_RESOURCES } from '@shared/utils';
 * 
 * // Use combined static resources
 * const allResources = Object.values(STATIC_RESOURCES);
 * ```
 */
export const STATIC_RESOURCES = {
  ...MODULE_RESOURCES,
  ...PAGE_RESOURCES,
  ...ROUTE_RESOURCES,
  ...DATABASE_RESOURCES,
  ...UI_RESOURCES,
  ...VIEW_RESOURCES,
} as const;
